import { CheckCircle2, Clock, MinusCircle, XCircle } from "lucide-react";

export function PlanCard({ plan, sent }) {
  if (!plan) return null;
  return (
    <div className="panel space-y-1 p-5" data-testid="assessment-plan">
      <p className="text-xs font-medium uppercase tracking-wide text-ink-muted">{sent ? "Sent" : "Will be sent"}</p>
      <p className="font-semibold" data-testid="assessment-plan-name">{plan.name} · v{plan.version}</p>
      <p className="text-sm text-ink-secondary">{plan.sections.join(" · ")}</p>
      <p className="inline-flex items-center gap-1 text-xs text-ink-muted"><Clock size={13} /> about {plan.minutes} min</p>
    </div>
  );
}

const optText = (q, id) => q.options.find((o) => o.id === id)?.text ?? id;

function AnswerRow({ q, ans, scored, ai }) {
  const shown = Array.isArray(ans) ? ans.map((x) => optText(q, x)).join(", ") : q.options.length ? optText(q, ans) : ans;
  const full = scored?.points != null && scored.points === scored.max;
  const Icon = scored?.points == null ? MinusCircle : full ? CheckCircle2 : scored.points > 0 ? MinusCircle : XCircle;
  const color = scored?.points == null ? "text-ink-muted" : full ? "text-success" : scored.points > 0 ? "text-caution" : "text-risk";
  const key = q.options.filter((o) => o.correct).map((o) => o.text).join(", ");
  return (
    <li className="space-y-1 border-b border-line py-3 last:border-0" data-testid={`extra-result-${q.id}`}>
      <div className="flex items-start gap-2">
        <Icon size={16} className={`mt-0.5 shrink-0 ${color}`} aria-hidden />
        <p className="flex-1 text-sm font-medium">{q.prompt}</p>
        <span className="text-xs tabular-nums text-ink-muted">{scored?.points != null ? `${scored.points}/${scored.max}` : q.scored === false ? "Not scored" : "Scoring…"}</span>
      </div>
      <p className="pl-6 text-sm text-ink-secondary">{shown || <i>No answer</i>}</p>
      {key && !full && <p className="pl-6 text-xs text-ink-muted">Correct: {key}</p>}
      {ai && <p className="pl-6 text-xs text-ink-muted">{ai.rationale}{ai.evidence && <> · "{ai.evidence}"</>}</p>}
    </li>
  );
}

export function ExtraResults({ a }) {
  const res = a.results_extra;
  if (!a.extra_sections?.length || !res) return null;
  const scores = Object.fromEntries((res.sections || []).flatMap((s) => s.items.map((i) => [i.id, i])));
  return (
    <section className="panel space-y-4 p-5" data-testid="extra-results">
      <div className="flex flex-wrap items-baseline gap-4">
        <h3 className="text-base font-semibold">Skills & custom questions</h3>
        {res.quiz_score != null && <span className="text-sm">Score <b className="font-display tabular-nums" data-testid="extra-quiz-score">{res.quiz_score}</b>/100</span>}
        {res.overall != null && <span className="text-sm">Overall assessment <b className="font-display tabular-nums" data-testid="extra-overall">{res.overall}</b>/100</span>}
        {res.pending_ai > 0 && <span className="text-xs text-ink-muted">{res.pending_ai} written answer(s) still being scored</span>}
      </div>
      {a.extra_sections.map((s) => (
        <div key={s.id}><p className="text-sm font-medium text-ink-secondary">{s.title}</p>
          <ul>{s.questions.map((q) => <AnswerRow key={q.id} q={q} ans={(a.extra_answers || {})[q.id]} scored={scores[q.id]} ai={(res.ai || {})[q.id]} />)}</ul></div>
      ))}
    </section>
  );
}
